module.exports = __webpack_public_path__ + "static/sui-table-highlight-2ee0685d4581ef67f5d9aef9382ccbe4.png";